module.exports = __webpack_public_path__ + "img/refresh.6a41b75b.svg";